import { Box, Text } from "@chakra-ui/react";
import { FC, Fragment } from "react";
import { BackButton } from "../BackButton/BackButton";

interface HeaderProps {
  title: string;
  screen?: string;
  funcBack?: () => void;
}

export const Header: FC<HeaderProps> = (props) => {
  return (
    <Fragment>
      <Box
        display={{ base: "flex", md: "none" }}
        alignItems="center"
        justifyContent="center"
        position="relative"
        px="25.7px"
        py="17px"
        bg="#FFFFFF"
        borderBottom={`1px solid #F1F1F1`}
      >
        <Box
          position="absolute"
          top="50%"
          left="22.7px"
          transform="translateY(-50%)"
        >
          <BackButton funcBack={props.funcBack} screen={props.screen} />
        </Box>
        <Text fontSize="16px" fontWeight="bold" color="#000000">
          {props.title}
        </Text>
      </Box>
    </Fragment>
  );
};
